import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=0af99f13&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=0af99f13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af99f13",
  null
  
)

export default component.exports